
import * as React from "react";
import CountDownComp from "../global/CountDownComp";
import { ISetUrl } from "../../AppMain";
import { IActiveOrders } from "../../interfaces/IOrder";
import DateTool from "../../../avernus/datetool/source/DateTool";
import { Api } from "../../lib/Api";
import { Lng } from "../../../languages/Languages";
import Header from "../Header";
import OrderStatusLabel from "./OrderStatusLabel";
import LoaderComp from "../../../avernus/loader/source/LoaderComp";

interface IActiveOrdersProps {
    setUrl: any
}

interface IActiveOrdersState {
    orders: any,
    loading: boolean
}

export default class ActiveOrders extends React.Component<IActiveOrdersProps, IActiveOrdersState>{

    constructor(props:IActiveOrdersProps){
        super(props);
        this.state = {
            orders: [],
            loading: true
        };

        this.init();
    }


    private init(){
        Api.call('/user/order/getActiveOrders', {}, (result) =>{
            this.setState({
                orders: result.items,
                loading: false
            })
        } );
    }

    private item(order){
        return (
              <div className="order" onClick={() => this.props.setUrl('/user/order', { order: order})}>
                    <div className = "main-content">
                        {
                            order.offer.creator.photos?.profilePhoto.length > 0 &&
                            <div className = "profile-image">
                                <div className = "image">
                                    <img src={order.offer.creator.photos?.profilePhoto} />
                                </div>
                            </div>
                        }

                          <div className = "content">
                              <p className="name">{order.offer.creator.name}</p>
                              <p className="offer-type">{order.offer.offerType.name}</p>
                              <p className="offer-hours">{order.hours} hours</p>
                              {
                                  order.offer.creator.rateing > 0 &&
                                  <span className="rateing_star_inline_box">
                                      { order.offer.creator.rateing >= 1?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                      { order.offer.creator.rateing >= 2?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                      { order.offer.creator.rateing >= 3?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                      { order.offer.creator.rateing >= 4?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                      { order.offer.creator.rateing >= 5?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                  </span>
                              }
                              <hr/>
                              <p className = "price">{order.price} {order.currency}</p>
                          </div>
                    </div>
                  <OrderStatusLabel order={order} />

              </div>
        );
    }



    render() {

        return (
            <div className = "active_orders">
                {
                    this.state.loading ?
                        <LoaderComp show={true} /> :
                        (this.state.orders &&
                            <>
                                {
                                    this.state.orders.map((order, i) => (
                                        this.item(order)
                                    ))
                                }
                            </>
                        )
                }


            </div>
        );
    }
}
